<template>
    <v-footer dark padless>
        <v-card flat tile class="secondary white--text text-center">
            <v-card-text>
                <v-btn
                    v-for="(icon, i) in icons"
                    :key="i"
                    class="mx-4 white--text"
                    :href="icon.link"
                    target="_blank"
                    icon
                    >
                    <v-icon size="24px">{{ icon.text }}</v-icon>
                    </v-btn>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    name:'FooterComponent',
    data: () => ({
    icons: [
        {
            text: "mdi-facebook",
            link: "https://www.facebook.com/ciertocaiman",
        },
        {
            text: "mdi-twitter",
            link: "https://twitter.com/ciertocaiman",
        },
        {
            text: "mdi-earth",
            link: "https://josesantiago-be014.web.app/",
        },
        {
            text: "mdi-instagram",
            link: "https://www.instagram.com/unjosesantiago",
        },
        ],
    }),
}
</script>

<style scoped>
.v-card {
  width: 100%;
}

</style>